import ChoixPatient from '@/components/choix-patient'
import DateFilter from '@/components/date-filter';
import InfoOperationRST from '@/components/caisse/factures/info-operation'
import { cca_config } from '../../../../../CCA_ENV_CONF/env';
import store_operation from "@/store/mods/caisse/operations"
import store_patient from '@/store/mods/clinique/patients'
import $ from 'jquery'


export default {
    name: 'patients-operations',
    components: {
        ChoixPatient, DateFilter, InfoOperationRST
    },
    props: [],
    data() {
        return {
            is_list_patient: true,
            selected_patient: {
                patient_id: '',
                nom_patient: '',
                sexe: '',
                telephone_mobile: '',
                age: ''
            },

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            operation_filters: [
                { id: 0, libelle: 'En attente' }, { id: 2, libelle: 'Différées' },
                { id: 3, libelle: 'Reste à payer' }, { id: 1, libelle: 'Payées' }
            ],
            filter_operation: { id: 0, libelle: 'En attente' },

            search_operation: '',

            libelle_action: 'Payer',
            can_do_action: false,

            is_loading: true,
            is_empty: false,
            is_load_error: false,

            liste_operations_patient: [],

            fields: [
                { key: 'choix_operation', label: '#' }, { key: 'ref', label: 'Référence' }, { key: 'designation', label: 'Désignation' },
                { key: 'qte', label: 'Qté' }, { key: 'prix_unitaire', label: 'P.U.' }, { key: 'montant', label: 'Montant dû' },
                { key: 'a_payer', label: 'À payer' }, 'date'
            ],

            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,

            selected_operations: [],

            aib_liste: [
                {
                    libelle: 'N/A',
                    taux: 0,
                    slug: 'n_a'
                }
            ],
            selected_aib: {
                libelle: '',
                taux: 0,
                slug: ''
            },
            info_operation: {},
            montant: {
                amount_differes: 0,
                amount_rap: 0
            },
            amount_is_loading: true,
            amount_error: false,
            info_assurance_patient: {}
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.selected_operations = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                etat_paiement: this.filter_operation.id,
                patient_id: this.selected_patient.patient_id,
                aib: this.selected_aib.slug
            }
            this.current_date_filter = data
            this.is_month = true

            if (this.selected_patient.patient_id > 0) {
                this.getListeOperations(data)
            }
        },

        filter_operation() {
            const is_vente_caisse = (this.filter_operation.id == 0)?0:1

            this.$store.commit("SET_IS_VENTE_FROM_CAISSE", is_vente_caisse);
            this.selected_operations = []
            if (this.filter_operation.id == 1) {
                this.libelle_action = 'Générer facture'
            } else {
                this.libelle_action = 'Payer'
            }

            if (cca_config.IS_SFE) {
                this.selected_aib = {
                    libelle: 'N/A',
                    taux: 0,
                    slug: 'n_a'
                }
            }

            const data = {
                month: this.curr_month.id,
                one_date: this.current_date_filter.one_date,
                from_date: this.current_date_filter.from_date,
                to_date: this.current_date_filter.to_date,
                etat_paiement: this.filter_operation.id,
                patient_id: this.selected_patient.patient_id,
                aib: this.selected_aib.slug
            }
            this.current_date_filter = data
            if (this.selected_patient.patient_id > 0) {
                this.getListeOperations(this.current_date_filter)
            }
            this.setDataTHead()
        },

        selected_aib() {
            this.selected_operations = []

            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                etat_paiement: this.filter_operation.id,
                patient_id: this.selected_patient.patient_id,
                aib: this.selected_aib.slug
            }
            this.current_date_filter = data
            if (this.selected_patient.patient_id > 0) {
                this.getListeOperations(this.current_date_filter)
            }
        },

        selected_operations() {
            if (this.selected_operations.length > 0) {
                this.can_do_action = true
            } else {
                this.can_do_action = false
            }
        },

        is_list_patient() {
            if (!this.is_list_patient) {
                this.getPatientInfoAssurance()
                this.getPatientMontantResteAPayer()
            }
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        selected_patient_attente() {
            return this.$store.getters['selected_patient_attente'];
        },

        sfe_liste_aib() {
            return this.$store.getters['sfe_liste_aib'];
        },

        can_add_differential_computing() {
            return this.$store.getters["can_add_differential_computing"]
        },

        payment_action() {
            return this.$store.getters["payment_action"]
        },
    },

    mounted() {
        this.monthOfYear[0].lib = "Toutes les périodes"
        this.$store.commit("SET_IS_VENTE_FROM_CAISSE", 0);
        this.curr_month = this.monthOfYear[this.current_date.getMonth() + 1]

        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        // Check if Differential computing should be applied
        this.$store.dispatch('getDifferentialComputing')

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js
        this.$store.commit("SET_BILL_SELECTED_OPERATIONS", []);
        this.$store.commit("SET_PAYING_BILL_STATE", '');
        this.$store.commit("SET_IS_PAID", false);
        this.$store.commit("SET_SELECTED_SFE_AIB", {});

        this.setSelectedPatientEnAttente()

        this.getListeAibSFE()

        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };

        if (this.payment_action != '') {
            this.setPaymentAction()
        }
    },

    methods: {
        setPaymentAction() {
            if (this.payment_action == 'rap') {
                this.filter_operation = { id: 3, libelle: 'Reste à payer' }
            } else if (this.payment_action == 'differe') {
                this.filter_operation = { id: 2, libelle: 'Différées' }
            }
        },

        getListeAibSFE() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {

                const listes_aib = Object.keys(this.sfe_liste_aib);
                const aib_items = ['aibA', 'aibB']

                listes_aib.forEach(key => {
                    if (aib_items.includes(key)) {
                        const tmp_aib = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_liste_aib[key],
                            slug: key
                        }
                        this.aib_liste.push(tmp_aib)
                    }
                });
            })
        },

        setSelectedPatient(patient_data) {
            this.selected_patient = patient_data

            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                etat_paiement: this.filter_operation.id,
                patient_id: this.selected_patient.patient_id,
                aib: this.selected_aib.slug
            }
            this.current_date_filter = data
            this.getListeOperations(this.current_date_filter)

            this.is_list_patient = false
        },

        setSelectedPatientEnAttente() {
            if (this.selected_patient_attente?.patient_id) {
                this.setSelectedPatient(this.selected_patient_attente)
            }
        },

        backToChoixPatient() {
            this.is_list_patient = !this.is_list_patient
        },

        refreshOperations() {
            this.getListeOperations(this.current_date_filter)
        },

        getListeOperations(data) {
            this.is_load_error = false
            this.is_loading = true
            store_operation.getListeOperationsPatient(data).then((operations) => {
                this.liste_operations_patient = operations
                if (this.liste_operations_patient.length > 0) {
                    this.liste_operations_patient.forEach((operation, index) => {
                        const base_assurance = operation.base_assurance
                        const taux_couverture = operation.taux_assurance
                        const pu = operation.prix_unitaire
                        const qte = operation.qte
                        const est_exclu = operation.est_exclu
                        if (data.etat_paiement == 0) {
                            const param_assure = {
                                base_assurance: base_assurance,
                                prix_assure_clinique: operation.prix_assure_clinique,
                                taux_couverture: taux_couverture,
                                pu: pu,
                                qte: qte,
                                est_exclu: est_exclu,
                                etat_autorisation: operation.etat_demande_autorisation
                            }
                            this.liste_operations_patient[index].montant_du = this.calculatePartAssure(param_assure)
                            this.liste_operations_patient[index].montant_net_a_solder = this.calculatePartAssure(param_assure)
                            this.liste_operations_patient[index].montant_restant = this.calculatePartAssure(param_assure)

                            this.liste_operations_patient[index].part_assureur = this.calculatePartAssureur(param_assure)
                        }
                        
                    });

                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        calculatePartAssure(param_assure) {
            let part_assure = 0
            if (param_assure.est_exclu == 0 && param_assure.base_assurance > 0) {
                if (this.can_set_pac && param_assure.prix_assure_clinique < param_assure.base_assurance) {
                    let tmp_part_assureur = 0
                    if (param_assure.base_assurance > 0) {
                        tmp_part_assureur = parseInt( (param_assure.taux_couverture * param_assure.base_assurance * param_assure.qte) / 100)
                    }

                    if (param_assure.prix_assure_clinique < param_assure.base_assurance) {
                        let total_pac = 0
                        if (param_assure.prix_assure_clinique > 0) {
                            total_pac =  param_assure.prix_assure_clinique * param_assure.qte

                            if (total_pac <= tmp_part_assureur) {
                                part_assure = 0
                            } else {
                                part_assure = total_pac - tmp_part_assureur
                            }
                        }
                    }
                } else {
                    if (this.can_add_differential_computing.response == "Oui") {
                        let pac = 0
                        if (this.can_set_pac) {
                            pac = (param_assure.prix_assure_clinique === '')?0:param_assure.prix_assure_clinique
                        } else {
                            pac = param_assure.pu
                        }

                        const prix_additionnel = (pac > param_assure.base_assurance)?(pac - param_assure.base_assurance):0
                        part_assure = Math.ceil( ( ( (100 - param_assure.taux_couverture) / 100 ) * param_assure.base_assurance ) +
                            +  parseInt(prix_additionnel) ) * param_assure.qte
                    } else {
                        part_assure = ( Math.ceil( ( (100 - param_assure.taux_couverture) / 100 ) * param_assure.base_assurance ) * param_assure.qte)
                    }
                }
            } else {
                part_assure = param_assure.qte * param_assure.pu
            }
            return part_assure;
        },

        calculatePartAssureur(param_assure) {
            let part_assureur = 0
            let total_pac =  param_assure.prix_assure_clinique * param_assure.qte
            let tmp_part_assureur = 0
            if (param_assure.base_assurance > 0) {
                tmp_part_assureur = parseInt( (param_assure.taux_couverture * param_assure.base_assurance * param_assure.qte) / 100) 
            }
            
            if (this.can_set_pac) {
                if (total_pac <= tmp_part_assureur) {
                    part_assureur = total_pac
                } else {
                    part_assureur = tmp_part_assureur
                }
            } else {
                part_assureur = tmp_part_assureur
            }
            
            return part_assureur;
        },

        filterByDate(date) {
            this.selected_operations = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                etat_paiement: this.filter_operation.id,
                patient_id: this.selected_patient.patient_id,
                aib: this.selected_aib.slug
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getListeOperations(data)
        },

        setDataTHead() {
            if (this.filter_operation.id == 1) {
                this.fields = [
                    { key: 'choix_operation', label: '#' }, { key: 'ref', label: 'Référence' }, { key: 'designation', label: 'Désignation' },
                    { key: 'qte', label: 'Qté' }, { key: 'prix_unitaire', label: 'P.U.' }, 
                    { key: 'montant', label: 'Montant dû' },
                    { key: 'montant_paye', label: 'Payé' }, 'date'
                ]
            } else if (this.filter_operation.id == 0 || this.filter_operation.id == 2) {
                this.fields = [
                    { key: 'choix_operation', label: '#' }, { key: 'ref', label: 'Référence' }, { key: 'designation', label: 'Désignation' },
                    { key: 'qte', label: 'Qté' }, { key: 'prix_unitaire', label: 'P.U.' }, { key: 'montant', label: 'Montant dû' },
                    { key: 'a_payer', label: 'À payer' }, 'date'
                ]
            } else if (this.filter_operation.id == 3) {
                this.fields = [
                    { key: 'choix_operation', label: '#' }, { key: 'ref', label: 'Référence' }, { key: 'designation', label: 'Désignation' },
                    { key: 'qte', label: 'Qté' }, { key: 'prix_unitaire', label: 'P.U.' }, { key: 'montant', label: 'Montant dû' },
                    { key: 'montant_paye', label: 'Payé' }, { key: 'a_payer', label: 'Restant' }, 'date'
                ]
            }
         },

        setAction() {
            const operation_length = this.selected_operations.length

            if (operation_length == 0) {
                // TODO : Show error message
                return;
            }

            this.selected_operations.forEach(operation => {
                if (operation.data_type == 'bon_consultation' && operation.info_apport_social != null) {
                    this.selected_operations.push(operation.info_apport_social)
                }
            });

            const tmp_grouped_operations = this.selected_operations.groupBy('data_type')
            let grouped_operations = []

            for (const key in tmp_grouped_operations) {

                if (key == 'chirurgie') {
                    const tmp_grouped_prestations = tmp_grouped_operations[key].groupBy('chirurgie')

                    for (const key_prest in tmp_grouped_prestations) {
                        // Calcul sous total
                        let sous_total = 0
                        let operations_len = tmp_grouped_prestations[key_prest].length
                        tmp_grouped_prestations[key_prest].forEach(operations => {
                            sous_total += operations.montant_paye
                        });
                        
                        const tmp_group = {
                            data_type: key,
                            group_prestation: tmp_grouped_operations[key][0].group_prestation,
                            prestations: tmp_grouped_prestations[key_prest],
                            chirurgie: key_prest,
                            taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                            aib: tmp_grouped_operations[key][0].aib,
                            sous_total: sous_total,
                            can_show_subtotal: (operations_len > 1)?true:false
                        } 
                        grouped_operations.push(tmp_group) 
                    }
                } else {
                    // Calcul sous total
                    let sous_total = 0
                    let operations_len = tmp_grouped_operations[key].length
                    tmp_grouped_operations[key].forEach(operations => {
                        let montant = (operations.data_type == 'apport_social')?-operations.montant_paye:operations.montant_paye
                        sous_total += montant
                    });

                    const tmp_group = {
                        data_type: key,
                        group_prestation: (tmp_grouped_operations[key][0].data_type != 'apport_social')?tmp_grouped_operations[key][0].group_prestation:'Apport social',
                        prestations: tmp_grouped_operations[key],
                        taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                        aib: tmp_grouped_operations[key][0].aib,
                        sous_total: sous_total,
                        can_show_subtotal: (operations_len > 1)?true:false,
                        is_vente_caisse: 0
                    }
                    grouped_operations.push(tmp_group)
                }
            }

            this.$store.commit("SET_BILL_SELECTED_OPERATIONS", grouped_operations);
            
            this.$store.commit("SET_PATIENT", this.selected_patient);
            this.$store.commit("SET_PAYING_BILL_STATE", this.filter_operation.id);

            if (this.filter_operation.id == 1) {
                this.$store.commit("SET_SELECTED_SFE_AIB", this.selected_aib);
                this.$router.push({ path: '/factures/pro-facture' })
            } else {
                this.$router.push({ path: '/factures/paiement' })
            }
        },

        checkAll() {
            let is_checked = $('#check-all').is(":checked")

            if (is_checked) {
                this.selected_operations = []

                this.liste_operations_patient.forEach((operation) => {
                    this.selected_operations.push(operation)
                });
                this.all_checked = true
                
            } else {
                this.selected_operations = []
                this.all_checked = false
            }
        },

        onOneChange() {
            document.getElementById("check-all").checked = false;
        },

        viewInfo(info_operation) {
            this.info_operation = info_operation

            setTimeout(() => {
                $('.p-info-rst-'+info_operation.id).modal('show')
            }, 500);
        },

        viewOpInfo(info_operation) {
            this.info_operation = info_operation

            setTimeout(() => {
                $('.p-infop-'+info_operation.operation_id).modal('show')
            }, 500);
        }, 

        viewOpInitial(info_operation) {
            this.info_operation = info_operation

            setTimeout(() => {
                $('.p-infoinit-'+info_operation.operation_id).modal('show')
            }, 500);
        },

        getPatientMontantResteAPayer() {
            this.amount_error = false
            this.amount_is_loading = true
            const data = {
                patient_id: this.selected_patient.patient_id
            }
            store_operation.getPatientResteApayer(data).then((response) => {
                this.montant.amount_differes = response.amount_differes
                this.montant.amount_rap = response.amount_rap

                this.amount_is_loading = false
            }).catch(() => {
                this.amount_is_loading = false
                this.amount_error = true
            })
        },

        getPatientInfoAssurance() {
            store_patient.getPatientInsuranceInfo(this.selected_patient.patient_id).then((response) => {
                this.info_assurance_patient = response
            })
        }
    }
}